<div *ngIf="formControl.value as baseProduct; else alert">
  <span>Nome: </span><b>{{ baseProduct.name }}</b><br />
  <span>Preço Mínimo: </span><b>R$ {{ baseProduct.price }}</b>
</div>
<ng-template #alert>
  <vdr-card>
    <span style="color: red">
      <cds-icon
        shape="exclamation-triangle"
        size="lg"
      />
      {{'grupo-loja.missing-base-product' | translate}}
    </span>
  </vdr-card>
</ng-template>
<br />
<span>Para mudar o produto base, selecione um novo abaixo</span>
<select
  class="mt-1"
  [formControl]="formControl"
>
  <option [ngValue]="null">Selecione um produto base</option>
  <option
    *ngFor="let item of baseProducts$ | async"
    [ngValue]="item"
  >
    {{ item.name }}
  </option>
</select>
